import { ClientJS } from 'clientjs'

export default defineNuxtPlugin(() => {
  return {
    provide: {
      clientJS: new ClientJS(),
    },
  }
})
